var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticClass:"displayno",attrs:{"type":"file","id":"pre_file"},on:{"change":_vm.getFilePath}}),_c('a',{attrs:{"id":"pre_downlink"}}),_c('a',{attrs:{"id":"pre_loodlink","target":"_blank"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }